import React, { useState, useEffect } from "react";
import { Col, Container, Form, Row, Button } from "react-bootstrap";
import { Icon } from "@iconify/react";



const BlogContactForm = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        companyName: "",
        source: "Website",
        contactNumber: "",
        selectLocation: "",
        selectNoOfProducts: "",
        comments: "",
        subSource: "",
        utmsource: "",
        utm_campaign: "",
        utm_device: "",
        utmmedium: "",
        utm_term: "",
        utm_network: "",
        utm_content: "",
    });

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // On load: capture URL and UTM params
        const url = window.location.href;
        const params = new URLSearchParams(window.location.search);

        const updatedData = {
            subSource: url,
            utmsource: params.get("utm_source") || "Organic",
            utm_campaign: params.get("utm_campaign") || "Organic",
            utm_device: params.get("utm_device") || "desktop",
            utmmedium: params.get("utm_medium") || "Organic",
            utm_term: params.get("utm_term") || "Organic",
            utm_network: params.get("utm_network") || "Organic",
            utm_content: params.get("utm_content") || "Organic",
        };

        setFormData((prev) => ({ ...prev, ...updatedData }));
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const googleScriptUrl =
            "https://script.google.com/macros/s/AKfycbz8wlhLNBQgjQJtt0iqubkyIBIoxM-eOVGeMtmPj3CQY5IlzA5LgUuCcHtjprhT1VaH/exec";

        const payload = {
            // access_code: "8F18-F3A4-EE3D-7FF4-1FA2-6F9F",
            access_code:"1BEA-BAFF-A9D4-54DC-860C-4B5F",
            name: formData.name,
            email: formData.email,
            phone: formData.contactNumber,
            source: formData.source,
            // additional_col1_select: formData.selectLocation,
            location:formData.selectLocation,
            company_name: formData.companyName,
            enquiry: formData.comments,
            no_of_products: formData.selectNoOfProducts,
            sub_source: formData.subSource,
            utm_source: formData.utmsource,
            utm_campaign: formData.utm_campaign,
            utm_device: formData.utm_device,
            utm_medium: formData.utmmedium,
            utm_term: formData.utm_term,
            utm_network: formData.utm_network,
            utm_content: formData.utm_content,
        };

        const formDataToSubmit = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
            formDataToSubmit.append(key, value);
        });

        const urlEncodedFormData = new URLSearchParams();
        Object.entries(formData).forEach(([key, value]) => {
            urlEncodedFormData.append(key, value);
        });


        try {
            const [leadApiResText] = await Promise.all([
                // Lead API
                // fetch("https://growtheye.com/leadApiBeta.php", {
                // fetch("https://leadapi.scaledino.com/api/leads/web", {
                fetch("https://leadapi.growtheye.com/api/leads/web",{
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }).then((res) => res.text()),

                // Google Script (no-cors mode)
                await fetch(googleScriptUrl, {
                    method: "POST",
                    mode: "no-cors",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: urlEncodedFormData.toString(),
                })
            ]);

            if (leadApiResText.trim() !== "SUCCESSRound Robin Code Started") {
                console.error("Lead API Error:", leadApiResText);
            }

            window.location.href = `/thank-you?email=${encodeURIComponent(formData.email)}&name=${encodeURIComponent(formData.name)}`;
        } catch (error) {
            console.error("Submission error:", error);
            alert("There was an error with the form submission.");
        } finally {
            setLoading(false);
        }
    }
    return (
        <>
            <Container>
                <Row>
                    <Col md={12}>
                        <div className="shadow-lg">
                            <div>
                                <p className="bgeYantraOrange text-white fs-24 text-center rounded-top p-2">
                                    Get In Touch
                                </p>
                                <Form className="p-0 mx-3" onSubmit={handleSubmit}>
                                    <label htmlFor="name" className="fw-normal fs-18 mx-1 mt-2">Name:*</label>
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control bgContactFormInput px-2 py-2 mx-1 border-dark"
                                        value={formData.name}
                                        onChange={handleChange}
                                        placeholder="Your Name"
                                        required
                                    />
                                    <label htmlFor="company-name" className="fw-normal fs-18 mx-1 mt-2">Company Name:*</label>
                                    <input
                                        type="text"
                                        name="companyName"
                                        className="form-control bgContactFormInput px-2 py-2 mx-1 border-dark"
                                        value={formData.companyName}
                                        onChange={handleChange}
                                        placeholder="Your Company Name"
                                        required

                                    />
                                    <label htmlFor="work-email" className="fw-normal fs-18 mx-1 mt-2">Work Email:*</label>
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control bgContactFormInput px-2 py-2 mx-1 border-dark"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="Work Email"
                                        required

                                    />
                                    <label htmlFor="phoneNumber" className="fw-normal fs-18 mt-2 mx-1 ">Phone Number:*</label>
                                    <input
                                        type="text"
                                        name="contactNumber"
                                        className="form-control bgContactFormInput px-2 py-2 mx-1 border-dark"
                                        pattern="[6-9]{1}[0-9]{9}"
                                        title="Enter a valid contact number"
                                        value={formData.contactNumber}
                                        onChange={handleChange}
                                        placeholder="Your Contact Number"
                                        maxlength="10"
                                        required
                                    />
                                    <label htmlFor="selectLocation" className="fw-normal fs-18 mx-1 mt-2">Location:*</label>
                                    <select
                                        name="selectLocation"
                                        className="form-control bgContactFormInput px-2 py-2 mx-1 border-dark"
                                        value={formData.selectLocation}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="" hidden>
                                            Select Location
                                        </option>
                                        <option value="Hyderabad">Hyderabad</option>
                                        <option value="Bangalore">Bangalore</option>
                                        <option value="Gurugram">Gurugram</option>
                                        <option value="Delhi">Delhi</option>
                                        <option value="Noida">Noida</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    <label htmlFor="selectNo.ofproducts" className="fw-normal fs-18 ms-1 mt-2">No.of Products:*</label>
                                    <select
                                        name="selectNoOfProducts"
                                        className="form-control bgContactFormInput px-2 py-2 mx-1 border-dark"
                                        value={formData.selectNoOfProducts}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="" hidden>
                                            No. Of Products
                                        </option>
                                        <option value="50-100 products">50-100 Products</option>
                                        <option value="100-200 products">100- 200 Products</option>
                                        <option value="200-300 products">200 - 300 Products</option>
                                        <option value="above500 products">Above 500 Products</option>
                                    </select>
                                    <label htmlFor="comment" className="fw-normal fs-18 mx-1 mt-2 mt-3">Enquiry:*</label>
                                    <textarea
                                        type="textarea "
                                        className="form-control bgContactFormInput px-2 py-2 mx-1 border-dark"
                                        placeholder="Enquiry"
                                        name="comments"
                                        value={formData.comments}
                                        onChange={handleChange}
                                    />
                                    <Button
                                        type="submit"
                                        className=" mx-1 my-3 rounded-pill py-2 px-4 border-0 fs-16"
                                        id="btnSubmit"
                                        disabled={loading}>
                                        {loading ? "Submitting..." : "Submit"}{" "}
                                        <Icon
                                            icon="tabler:circle-arrow-up-right-filled"
                                            width="24"
                                            height="24"
                                            style={{ color: "#fff" }} />
                                    </Button>
                                </Form>
                            </div>

                        </div>
                    </Col>
                </Row>

            </Container>
        </>
    )
}

export default BlogContactForm;